// Registers all runtime-resolved MF remotes; isolated so the MF runtime stays off the env.js read path.
import { registerRemotes } from '@module-federation/enhanced/runtime';

const RUNTIME_REMOTES = [
  { name: 'shipbob_design_system', settingKey: 'SHIPBOB_DESIGN_SYSTEM', required: true },
  { name: 'shipbob_mfe_runtime', settingKey: 'SHIPBOB_MFE_RUNTIME', required: true },
];

/** Register all runtime remotes from app settings; returns false if any required URL is missing. */
export function registerRuntimeRemotes(appSettings) {
  const settings = appSettings || {};
  const missingRequired = [];

  RUNTIME_REMOTES.forEach(({ name, settingKey, required }) => {
    const value = settings[settingKey];
    if (typeof value !== 'string' || !value.trim()) {
      if (required) missingRequired.push(settingKey);
      else console.error(`[token-management-ui] ${settingKey} missing; skipping ${name} remote`);
      return;
    }
    const origin = value.trim().replace(/\/$/, '');
    registerRemotes([{ name, entry: `${origin}/remoteEntry.js` }], { force: true });
  });

  return missingRequired.length === 0;
}
